import type { IDepositSchedule } from "@/modules/deposit/common/types";
import { CURRENCY } from "@/shared/common/constants";
import { formatDate } from "@/shared/helpers";
import type { ICellProps } from "@ab.uitools/ui-library/components/AdvancedTable/types";

interface Props {
  t: (s: string) => string;
}

export const getColumns = ({ t }: Props) => ([
  {
    id: "paymentDate",
    header: t("deposits.scheduleTable.paymentDate"),
    accessorKey: "paymentDate",
    enableHiding: false,
    cell: ({ row }: ICellProps<IDepositSchedule>) => {
      return formatDate(row.original?.paymentDate);
    }
  },
  {
    id: "principalAmount",
    header: t("deposits.scheduleTable.principalAmount"),
    accessorKey: "principalAmount",
    enableHiding: false,
    cell: ({ row }: ICellProps<IDepositSchedule>) => {
      const amount = row.original?.principalAmount;
      const currency = row.original?.currency;
      return `${amount} ${CURRENCY[currency]?.symbol}`;
    },
  },
  {
    id: "interestAmount",
    header: t("deposits.scheduleTable.interestAmount"),
    accessorKey: "interestAmount",
    enableHiding: false,
    cell: ({ row }: ICellProps<IDepositSchedule>) => {
      const interestAmount = row.original?.interestAmount;
      const currency = row.original?.currency;
      return `${interestAmount} ${CURRENCY[currency]?.symbol}`;
    },
  },
  {
    id: "totalAmount",
    header: t("deposits.scheduleTable.totalAmount"),
    accessorKey: "totalAmount",
    enableHiding: false,
    cell: ({ row }: ICellProps<IDepositSchedule>) => {
      const totalAmount = row.original?.totalAmount;
      const currency = row.original?.currency;
      return `${totalAmount} ${CURRENCY[currency]?.symbol}`;
    },
  },
]);
